import React, {useLayoutEffect,useMemo,useRef,useState} from 'react';
import {Outlet,useLocation} from 'react-router-dom';
import {useAuth} from '@/context/AuthContext';
import TodayNavigation from './TodayNavigation';
import {TotoAdaptiveDock} from './TotoAdaptiveSurface';
import {TodayLayoutContext} from './TodayLayoutContext';
import './today-layout.css';
import './room-assignments-material.css';
import './eg-material-refinements.css';
import {totoCollarNavigationColor} from '@/lib/totoCollarIdentity';
export default function TodayLayout() {
 const {user}=useAuth();
 const {pathname,search}=useLocation();
 const view=new URLSearchParams(search).get('view');
 const current=pathname==='/today/goals'?'goals':pathname==='/home'?'day':pathname==='/my-day'?(view==='guests'?'guests':'personal'):pathname==='/today/team'?(['eg','mt'].includes(view)?view:'team'):'eod';
 const [header,setHeader]=useState(null);
 const content=useRef(null);
 useLayoutEffect(()=>{if(content.current)content.current.scrollTop=0;},[pathname,search]);
 const snapshots=useMemo(()=>new Map(),[user?.user_id,user?.role,user?.boutique_code]);
 const layout=useMemo(()=>({header,snapshots}),[header,snapshots]);
 return <TodayLayoutContext.Provider value={layout}>
  <main className={`today-layout${current==='goals'?' today-layout--goals':current==='mt'?' today-layout--rooms':current==='eg'?' today-layout--eg':''}`} style={current==='goals'?{'--goals-navigation-color':totoCollarNavigationColor(user)}:undefined}>
   <section className="today-layout__vessel" aria-label="Today workspace">
    <div className="today-layout__heading" ref={setHeader}/>
    <div className="today-layout__navigation"><TodayNavigation owner user={user} current={current}/></div>
    <div ref={content} className="today-layout__content" data-today-content>
     {current==='mt'&&<div className="mt-room-navigation-actions" data-mt-unassigned-controls/>}
     <Outlet/>
    </div>
   </section>
   <TotoAdaptiveDock owner active={current==='personal'||current==='guests'?'my-day':'today'}/>
  </main>
 </TodayLayoutContext.Provider>;
}
